import { Avatar, AvatarFallback, AvatarImage } from '../../../../components/ui/avatar';
import { Envelope, Warning } from '../../../../design-system/icons';
import { avatarInitials } from '../avatarInitials';
import { AUTO_SENDER_LABEL } from './bulkSendCopy';

export interface ConfirmationRecipient {
  username: string;
  displayName?: string;
  avatarUrl?: string;
  /** Approved with no email yet: nothing goes out for this creator until one is added. */
  waiting?: boolean;
}

export type SummaryPerson = ConfirmationRecipient & { id: number };

const AVATAR_LIMIT = 4;

/** Figma 665:96219 / 680:64821: four overlapping avatars, then +N. */
export function RecipientAvatars({ people }: { people: SummaryPerson[] }) {
  if (people.length === 0) return null;
  const shown = people.slice(0, AVATAR_LIMIT);
  const more = people.length - shown.length;
  return (
    <div className="flex -space-x-2.5" aria-hidden="true">
      {shown.map((p) => (
        <Avatar key={p.id} className="ring-2 ring-white">
          {p.avatarUrl ? <AvatarImage src={p.avatarUrl} alt="" /> : null}
          <AvatarFallback className="bg-[#18181b] text-white">{avatarInitials(p.displayName ?? p.username)}</AvatarFallback>
        </Avatar>
      ))}
      {more > 0 ? <span className="flex size-8 items-center justify-center rounded-full bg-(--stone-100) text-xs font-medium text-[#404040] ring-2 ring-white">{`+${more}`}</span> : null}
    </div>
  );
}

export function EmailRow({ count }: { count: number }) {
  return (
    <li className="flex items-center gap-3 p-3 text-body-sm-regular text-foreground">
      <Envelope size={16} aria-hidden="true" />
      <span>Email</span>
      <span className="ml-auto truncate text-body-sm-medium">{`${count} from ${AUTO_SENDER_LABEL}`}</span>
    </li>
  );
}

export function WarningRow({ children }: { children: string }) {
  return (
    <li className="flex items-center gap-3 border-t border-(--stone-100) bg-[#fbf1e9] p-3 text-left text-body-sm-medium text-[#603b0b]">
      <Warning size={16} aria-hidden="true" className="shrink-0" />
      <span>{children}</span>
    </li>
  );
}
